import axiosInstance from "@/api/axios";

export default {
namespaced: true,
state: {
  commissions: [],
},
getters: {
    getAllCommissions(state) {
        return state.commissions;
    },

},
mutations: {
    setCommissions(state, commissions) {
        state.commissions = commissions;
    },
    ADD_COMMISSION(state, commission) {
        // edit commission if it already exists
        const existingIndex = state.commissions.findIndex(c => c._id === commission._id);
        if (existingIndex !== -1) {
            state.commissions.splice(existingIndex, 1, commission);
        } else {
            state.commissions.push(commission);
        }
    },
    REMOVE_COMMISSION(state, commissionId) {
        state.commissions = state.commissions.filter(commission => commission._id !== commissionId._id);
    }
},
actions: {
    createCommission({ commit, rootState }, params) {
        return new Promise((resolve, reject) => {
            axiosInstance(rootState.auth.token)
                .post("comission/add", params, {
                    Authorization: rootState.auth.token
                })
                .then(res => {
                    if (res.data.success) {
                        commit("ADD_COMMISSION", res.data.commission);
                        resolve(res.data.message);
                    } else {
                        reject(res.data.message);
                    }
                })
                .catch(error => {
                    console.error("API error:", error);
                    reject(
                        error.message || "An error occurred while creating the commission."
                    );
                });
        });
    },
    editCommission({ commit, rootState }, params) {
        return new Promise((resolve, reject) => {
            axiosInstance(rootState.auth.token)
                .post("comission/edit", params, {
                    Authorization: rootState.auth.token
                })
                .then(res => {
                    if (res.data.success) {
                        commit("ADD_COMMISSION", res.data.commission);
                        resolve(res.data.message);
                    } else {
                        reject(res.data.message);
                    }
                })
                .catch(error => {
                    console.error("API error:", error);
                    reject(
                        error.message || "An error occurred while editing the commission."
                    );
                });
        });
    },
    deleteCommission({ commit, rootState }, params) {
        return new Promise((resolve, reject) => {
            axiosInstance(rootState.auth.token)
                .post("comission/delete", params, {
                    Authorization: rootState.auth.token
                })
                .then(res => {
                    if (res.data.success) {
                        commit("REMOVE_COMMISSION", { _id: params.commissionId });
                        resolve(res.data.message);
                    } else {
                        reject(res.data.message);
                    }
                })
                .catch(error => {
                    console.error("API error:", error);
                    reject(
                        error.message || "An error occurred while deleting the commission."
                    );
                });
        });
    },
    commissionList({ commit, rootState }) {
        return new Promise((resolve, reject) => {
            axiosInstance(rootState.auth.token)
                .get("comission/list", {
                    Authorization: rootState.auth.token
                })
                .then(res => {
                    if (res.data.success) {
                        commit("setCommissions", res.data.commissions);
                        resolve(res.data.message);
                    } else {
                        reject(res.data.message);
                    }
                })
                .catch(error => {
                    console.error("API error:", error);
                    reject(
                        error.message || "An error occurred while creating the commission."
                    );
                });
        });
    },
    
    activeCommision({ rootState }, params) {
        return new Promise((resolve, reject) => {
            axiosInstance(rootState.auth.token)
                .get("comission/activeCommision", params, {
                      Authorization: rootState.auth.token
                })
                .then(res => {
                    if (res.data.success) {
                        resolve(res.data);
                    } else {
                        reject(res.data.message);
                    }
                })
                .catch(error => {
                    console.error("API error:", error);
                    reject(
                        error.message || "An error occurred while creating the commission."
                    );
                });
        });
    },
}
}